import React, {Component} from 'react';
import Alert from '../components/Alert';
import saveErrorUIComponent from './saveErrorUIComponent';

class ErrorUIComponent extends Component {
    constructor(props) {
    super(props);
    this.state = {hasError: false,textoError:'' };
}

componentDidCatch(error, info) {


    this.setState(
      {hasError: true,textoError:error.stack },
      ()=>saveErrorUIComponent(info.componentStack,this.state.textoError,this.props.children.props.fdvID).then(entry => {
              this.setState({mensajeError:entry.data.mensaje})
      })
    );


}


closeAlert = () => this.setState({hasError:false});
    


render() {
    if (this.state.hasError) {
        return  <Alert type='alert-danger alertModal' icon='ion-alert-circled' closeAlert={this.closeAlert}>
                  <p>Código de error {this.state.mensajeError}, comuníquese con mesa de ayuda.</p>
                </Alert>;
    } else {
        return this.props.children;
        }
    }
}

export default ErrorUIComponent;



// WEBPACK FOOTER //
// ./src/utils/ErrorUIComponent.js